<script lang="ts" setup>
import { formatValue } from '@forgd/formatter'
import { KpiStat } from '@forgd/ui-kit/blocks/kpi-stat'
import { SectionHeader, SectionHeaderActions, SectionHeaderDescription, SectionHeaderTitle } from '@forgd/ui-kit/section-header'
import { StatGroup } from '@forgd/ui-kit/stat'
import { Tabs, TabsIndicator, TabsList, TabsTriggerLink } from '@forgd/ui-kit/tabs'
import { useQuery } from '@pinia/colada'

const tabs = [
  { label: 'Active RFQs', to: '/active-rfqs' },
  { label: 'Closed RFQs', to: '/closed-rfqs' },
  { label: 'Quote Templates', to: '/quote-templates' },
]

const route = useRoute()

const { data, isPending } = useQuery({
  ...buildApiQuery('/rfq/mm/kpis', {
    method: 'get',
  }),
  refetchOnWindowFocus: false,
})

const kpis = computed(() => {
  return [{
    title: 'My Current Active RFQs',
    value: formatValue(data.value?.totalActiveRfqsQty, 'number:short'),
  }, {
    title: 'Lifetime Quotes Submitted',
    value: formatValue(data.value?.totalQuotesSubmitted, 'number:short'),
  }, {
    title: 'Lifetime Quotes Accepted',
    value: formatValue(data.value?.totalQuotesAccepted, 'number:short'),
  }, {
    title: 'Total Closed RFQs',
    value: formatValue(data.value?.totalClosedRfqsQty, 'number:short'),
  }]
})
</script>

<template>
  <div data-layout="home">
    <NuxtLoadingIndicator />
    <NuxtLayout name="dashboard">
      <div class="flex flex-col gap-10">
        <SectionHeader>
          <SectionHeaderTitle>Welcome to Forgd’s Liquidity Portal</SectionHeaderTitle>
          <SectionHeaderDescription class="xl:w-1/2">
            Track project’s RFQs, submit and evaluate competitors proposals, and engage with projects to increase your portfolio.
          </SectionHeaderDescription>
          <SectionHeaderActions>
            <AcademySlideoverButton path="/_liquidity/how-it-works" />
          </SectionHeaderActions>
        </SectionHeader>
        <StatGroup>
          <KpiStat
            v-for="kpi in kpis"
            :key="kpi.title"
            variant="inline"
            size="lg"
            :title="kpi.title"
            :value="kpi.value"
            :loading="isPending"
          />
        </StatGroup>
        <Tabs :model-value="route.path">
          <TabsList>
            <TabsTriggerLink v-for="tab in tabs" :key="tab.to" :to="tab.to">
              {{ tab.label }}
            </TabsTriggerLink>
            <TabsIndicator />
          </TabsList>
        </Tabs>
        <div>
          <slot />
        </div>
      </div>
    </NuxtLayout>
  </div>
</template>
